module.exports = __webpack_public_path__ + "cf14fada8ffdc8f7fc8b7fa748ef42f8.jpg";